var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHeartSolid = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.057 4.943c0.443-0.52 0.959-0.961 1.537-1.31l0.028-0.016c0.756-0.388 1.65-0.616 2.597-0.616 3.193 0 5.782 2.589 5.782 5.782 0 1.597-0.647 3.043-1.694 4.089l-8.308 8.308-8.309-8.308c-1.044-1.046-1.69-2.49-1.69-4.085 0-3.194 2.589-5.783 5.783-5.783 0.945 0 1.837 0.227 2.625 0.629l-0.033-0.015c0.64 0.382 1.193 0.822 1.68 1.324l0.002 0.002z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHeartSolid, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/heart-solid.2f90b64a.svg";
export { ForwardRef as ReactComponent };